module.exports = __webpack_public_path__ + "static/media/ribbon-specialoffer-it@2x.1b5c566c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ribbon-specialoffer-it@2x.png
// module id = 311
// module chunks = 0